import React from "react";

export default function RowControls({ controls, ...restProps }) {
  return (
    <div>
      {controls.map((Control) => (
        <Control key={Control.name} {...restProps} />
      ))}
    </div>
  );
}
